var render = function render(){var _vm=this,_c=_vm._self._c;return _c('inline-svg',{staticClass:"m-auto",class:{'cursor-pointer': _vm.deleteFilter},attrs:{"src":_vm.ICONS.bin,"fill-opacity":_vm.deleteFilter ? 1 : 0.25},on:{"click":() => { if (_vm.deleteFilter) {_vm.onDeleteConfirmation(_vm.item)} }}})
}
var staticRenderFns = []

export { render, staticRenderFns }